import React, { forwardRef } from "react"
import styled from "styled-components"
import useColor from "../../hooks/useColor"

export const TEXT_VARIANTS = Object.freeze({
	NORMAL: "normal",
	BOLD: "bold",
	ITALIC: "italic",
})

const Paragraph = styled.p`
	display: block;
	font-family: var(--font);
	font-weight: ${({ theme }) => theme?.fontWeight?.regular || 400};
	color: ${({ $color }) => $color || "var(--secondary-color)"};
	width: fit-content;

	&.${TEXT_VARIANTS.ITALIC} {
		font-style: italic;
		//padding-right: 1.5vw;
	}
	&.thin {
		font-weight: ${({ theme }) => theme?.fontWeight?.thin || 100};
	}
	&.light {
		font-weight: ${({ theme }) => theme?.fontWeight?.light || 200};
	}
	&.book {
		font-weight: ${({ theme }) => theme?.fontWeight?.book || 300};
	}
	&.semi-bold {
		font-weight: ${({ theme }) => theme?.fontWeight?.semiBold || 600};
	}
	&.bold {
		font-weight: ${({ theme }) => theme?.fontWeight?.bold || 700};
	}
	&.heavy {
		font-weight: ${({ theme }) => theme?.fontWeight?.heavy || 800};
	}
	&.black {
		font-weight: ${({ theme }) => theme?.fontWeight?.black || 900};
	}

	&.uppercase {
		text-transform: uppercase;
	}

	&.transparent-3d {
		color: transparent;
	}

	&.story {
		&.italic {
			padding-right: 2%;
		}
		background: linear-gradient(90deg, #836091 0%, #61989e 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`

const Text = forwardRef(function Text({ tag: tg = "p", as = undefined, className = "", children, color = "secondary", ...props }, ref) {
	const cl = useColor(color)
	const tag = as || tg
	return (
		<Paragraph as={tag} ref={ref} className={`${className} text`} $color={cl} {...props}>
			{children}
		</Paragraph>
	)
})

export default Text
